module.exports = __webpack_public_path__ + "static/media/logo-conciliador.86d51780.png";